import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { formatDate } from '../../Utils/utils';

const RomaneiosChart = ({ data }) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h5>Romaneios da última semana</h5>
        <p>Sem dados disponíveis.</p>
      </div>
    );
  }

  const chartData = data.map(d => ({
    data: formatDate(d.data),
    Entradas: Number(d.entry) || 0,
    Saídas: Number(d.exit) || 0
  }));

  return (
    <div style={{ textAlign: 'center', marginBottom: '20px' }}>
      <h5>Romaneios da última semana</h5>
      <ResponsiveContainer width="100%" height={350}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="data" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="Entradas" stroke="#0088FE" strokeWidth={2} />
          <Line type="monotone" dataKey="Saídas" stroke="#FF8042" strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RomaneiosChart;
